export const PUSH_NOTIFICATION_TITLE_MAX_LENGTH = 30;
export const PUSH_NOTIFICATION_TEXT_MAX_LENGTH = 160;

export const ACCEPTED_PERSONS_LIST_EXTENSIONS = ['csv'];
